import _constants from "./constants";
var exports = {};
var ASSETS_URLS = _constants.ASSETS_URLS;
function createAssetsUrl(authorization) {
  return ASSETS_URLS.production;
}
/* eslint-enable */

exports = {
  create: createAssetsUrl
};
export default exports;